export const csv2json = (csv) => {
    // console.log('mostrando csv', csv);
    var data=csv.split(";").filter(item=>item!=="").map((item)=>item.trim()).sort();
    data=data.filter((valor, indice) => {
        return data.indexOf(valor) === indice;
      });
    return data;
}